// extracted by mini-css-extract-plugin
export default {"deleteModal":"delete-modal_deleteModal__6B5z8","btnContainer":"delete-modal_btnContainer__OiQMr"};